var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#006EC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1412 19.4412V15.2059C27.1412 13.9578 26.6454 12.7608 25.7629 11.8783C24.8803 10.9958 23.6834 10.5 22.4353 10.5H14.4354C13.1873 10.5 11.9903 10.9958 11.1078 11.8783C10.2253 12.7608 9.72949 13.9578 9.72949 15.2059V21.7941C9.72949 22.4121 9.85121 23.024 10.0877 23.595C10.3242 24.1659 10.6708 24.6847 11.1078 25.1217C11.9903 26.0042 13.1873 26.5 14.4354 26.5H20.3271",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97461 23.2053L12.5534 20.1935C12.8921 19.8572 13.3366 19.6482 13.8117 19.6018C14.2867 19.5555 14.7632 19.6748 15.1605 19.9394C15.5577 20.2041 16.0342 20.3233 16.5093 20.277C16.9844 20.2307 17.4288 20.0217 17.7675 19.6853L19.9604 17.4924C20.5906 16.8601 21.4248 16.4723 22.3143 16.3982C23.2039 16.3241 24.0908 16.5684 24.8169 17.0877L27.1416 18.8853M14.6805 16.7771C14.8856 16.7758 15.0886 16.7342 15.2776 16.6545C15.4667 16.5749 15.6383 16.4588 15.7825 16.3128C15.9267 16.1669 16.0407 15.9939 16.1181 15.8039C16.1955 15.6139 16.2346 15.4105 16.2334 15.2053C16.2322 15.0001 16.1905 14.7972 16.1109 14.6081C16.0312 14.4191 15.9151 14.2475 15.7691 14.1033C15.6232 13.9591 15.4503 13.8451 15.2602 13.7677C15.0702 13.6903 14.8668 13.6511 14.6616 13.6524C14.2473 13.6549 13.8509 13.8219 13.5597 14.1166C13.2684 14.4114 13.1062 14.8098 13.1087 15.2241C13.1112 15.6385 13.2782 16.0349 13.573 16.3261C13.8677 16.6174 14.2661 16.7796 14.6805 16.7771Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.748 26.0281V21.3223",
    stroke: "white",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5898 24.0488L24.4411 25.9001C24.4814 25.9405 24.5292 25.9726 24.5818 25.9945C24.6345 26.0164 24.6909 26.0276 24.748 26.0276C24.805 26.0276 24.8614 26.0164 24.9141 25.9945C24.9667 25.9726 25.0145 25.9405 25.0548 25.9001L26.9061 24.0488",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.9c9129551fbfa3acd226df04d78d327d.svg";
export { ForwardRef as ReactComponent };